/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: constants.ts (Callback Profiles Constants)
 🗓️ Created: 2025-01-05
 🧩 Description:
    Constants for Callback Profiles module.

 🔧 Notes:
    - Strategy options
    - KNOWN_SETTINGS_KEYS and DEFAULT_FORM_STATE moved to utils/

 🔁 Last Updated: 2025-01-15 by Rodrigo Cuadra (Refactored)
────────────────────────────────────────────────────────────────*/

import { CallbackStrategy } from './types';

export const STRATEGY_OPTIONS: CallbackStrategy[] = [
  'same-queue',
  'overflow',
  'any-agent'
];

